<CPF-contract-details [contract]="contract"></CPF-contract-details>
